<template>
  <div>
    <div class="common-box border-t0" v-show="stepDisplay == '1'">
      <el-row class="row-one">
        <span class="row-one-title">恒宝宝定投</span>
        <Reback class="row-one-fr" @click.native="returnClick"></Reback>
        <span class="row-one-fr" @click="detailsClick">查看资产详情</span>
      </el-row>
      <!-- 表格1 -->
      <div class="hbbOpen">
        <p class="openTit">恒宝宝定期定额</p>
        <el-table v-loading="loadingOne" element-loading-text="加载中..." :data="openTableData" class="table-single">
          <el-table-column prop="tano" label="产品名称">恒宝宝</el-table-column>
          <el-table-column prop="fundcode" label="基金代码"></el-table-column>
          <el-table-column prop="fundname" label="基金名称"></el-table-column>
          <el-table-column prop="nav" label="基金净值"></el-table-column>
          <el-table-column prop="date" label="日期"> </el-table-column>
          <el-table-column prop="operation" label="操作" width="200">
            <template slot-scope="scope">
              <span class="table-single-btn-normal" @click="openingClick(scope.row)">开通</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChangeOne" :current-page.sync="pageOne.PageNum" :page-size="pageOne.pageSize" layout="prev, pager, next" :total="pageOne.total" hide-on-single-page>
        </el-pagination>
      </div>
      <!-- 说明 -->
      <section class="instruction">
        <div class="instruction-li">
          <p class="instruction-li-title">温馨提示</p>
          <p class="instruction-li-con">
            1. 如果您是农行电子支付卡用户，请先到农行柜台办理网银签约并下载证书。<br>
            2. 如果您是建行卡用户，请先将建行网站tttps//*.ccb.com.cn加为可信任站点，修改IE设置接收建行网站Cookie。 <br>
            3. 您对恒宝宝定期定额充值凯通/终止的操作记录可以在左侧导航栏“恒宝宝-交易记录”中进行查询。
          </p>
        </div>
      </section>
      <div v-if="warnFlag" class="bank-warn margin-t20">
        <span @click="$router.push({name:'accountManagement',params:{active:'2'}})">平台已开通新支付渠道，额度较之前有所提升。为了不影响定投正常扣款，请点此迁移新支付渠道，已迁移请忽略</span>
        <i class="el-icon-close" @click="warnFlag = false"></i>
      </div>
      <!-- 表格2 -->
      <div v-loading="loadingTwo" element-loading-text="加载中..." class="hbbOperation margin-t30">
        <el-table :data="operationTableData" class="table-single">
          <el-table-column prop="fundname" label="产品名称">恒宝宝</el-table-column>
          <el-table-column prop="firstdate" label="首次扣款日期">
          </el-table-column>
          <el-table-column prop="firstinvestamount" label="首次扣款金额（元）">
          </el-table-column>
          <el-table-column prop="periodremark" label="周期">
          </el-table-column>
          <el-table-column prop="account" label="扣款银行">
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="200">
            <template slot-scope="scope">
              <span class="table-single-btn-normal" @click="termination(scope.row)">终止</span>
              <span class="table-single-btn-normal" @click="fixedReviseClick(scope.row)">修改</span>
              <span class="table-single-btn-font" @click="pause(scope.row)">{{scope.row.status == 'P'? '恢复':'暂停'}}</span>
            </template>
          </el-table-column>
        </el-table>
        <!-- 页码 -->
        <el-pagination class="pagination-single" @current-change="handleCurrentChangeTwo" :current-page.sync="pageTwo.PageNum" :page-size="pageTwo.pageSize" layout="prev, pager, next" :total="pageTwo.total" hide-on-single-page>
        </el-pagination>
      </div>
    </div>
    <!-- 暂停恢复 -->
    <el-dialog class="dialog-single-three" :visible.sync="toggleDialogVisable" :close-on-click-modal="false" :before-close="cancelClick">
      <div class="dialog-single-three-p">{{toggleText}}</div>
      <el-form :model="cancelForm" ref="cancelFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="cancelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input v-model="cancelForm.pass" type="password" autocomplete="new-password" @blur="passBlur" show-password placeholder="请输入密码"></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="cancel" style="width:154px" @click="cancelClick">取消</el-button>
        <el-button type="normal1" @click="pauseSuccess">确认</el-button>
      </div>
    </el-dialog>
    <!-- 完善信息 -->
    <Perfect></Perfect>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dialogVisable1: false,
      stepDisplay: '1',
      terminationDialogVisible: false,
      openTableData: [],
      loadingOne: true,
      loadingTwo: true,
      pageOne: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      pageTwo: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      operationTableData: [],
      fixedText: '',
      // 投资终止确认
      inputType: '',
      confirmInput: '',
      // 弹框
      toggleDialogVisable: false,
      toggle: '暂停',
      // 暂停恢复
      toggleText: '',
      errorShow: false,
      errorMessage: '',
      buyplanno: '',
      cancelForm: {
        name: '',
        pass: ''
      },
      warnFlag: false,//汇付提醒
    }
  },
  mounted () {
    this.getfundList()
    this.getFixedLists()
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'myAssets',

      })
    },
    // 查看资产详情
    detailsClick () {
      this.$router.push({
        name: 'hbbAssetsMessage',
        params: {
          value: 'fixedInvestment'
        },
      })
    },
    // 开通
    openingClick (row) {
      this.dialogVisable1 = true
      this.$router.push({
        path: '/myAssets',
        name: 'fixedInvestmentOpening',
        params: {
          message: row,
        },
      })
    },
    // 终止
    termination (row) {
      this.$router.push({
        name: 'fixedStop',
        params: {
          fundMessage: row,
          name: 'fixedInvestment',
          title: '恒宝宝'
        }
      })
    },
    fixedReviseClick (row) {
      this.$router.push({
        name: 'fixedRevise',
        params: {
          fundMessage: row,
          name: 'fixedInvestment',
          title: '恒宝宝'
        }
      })
    },

    pauseSuccess () {
      this.getFixedLists()
      this.toggleDialogVisable = false
    },
    handleCurrentChangeOne (newPage) {
      this.pageOne.PageNum = newPage
      this.getfundList()
    },
    handleCurrentChangeTwo (newPage) {
      this.pageTwo.PageNum = newPage
      this.getFixedLists()
    },
    // 定投旗下列表
    getfundList () {
      this.$http.post(this.$apiPath.fundListFlag, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        qrytype: "",
        mktflag: "",
        busiflag: "1",
        inputvalue: 162206,
        requestid: 1,
      }).then(res => {
        this.loadingOne = false
        if (res.status !== 200 && res.data.code !== '200') return
        res.data.data.fundList.forEach(item => {
          item.date = this.$commonJs.getDateStrTh(item.navdate)
        });
        this.openTableData = res.data.data.fundList
        this.pageOne.total = res.data.data.totalNum
      }).catch(err => { })
    },
    // 定投记录
    getFixedLists () {
      this.$http.post(this.$apiPath.searchSavePlanList, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        saveplanflag: '1',
        fundcode: '162206',
        sellflag: '',
        requestid: 1,
      }).then(res => {
        // console.log(res);
        this.loadingTwo = false
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result.buyList.length > 0) {
          result.buyList.forEach(item => {
            item.firstdate = this.$commonJs.getDateStrTh(item.firstinvestdate)
            item.account = this.$commonJs.getBankInfo(item.channelid) + '(*' + item.depositacct.substring((item.depositacct).length - 4) + ')'
          });
          this.operationTableData = result.buyList
          this.pageTwo.total = res.data.data.totalNum
          this.warnFlag = true
        } else {
          this.warnFlag = false
        }
      }).catch(err => { })
    },
    // 暂停，恢复
    pause (row) {
      this.toggleText = row.status == 'P' ? '定投恢复' : '定投暂停'
      this.buyplanno = row.buyplanno
      this.toggleDialogVisable = true
    },
    passBlur () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
      }
    },
    cancelClick () {
      this.toggleDialogVisable = false
      this.errorMessage = ''
      this.$refs.cancelFormRef.resetFields()
    },
    // 暂停，恢复确认
    pauseSuccess () {
      var inputpwd = this.$des.enString(this.cancelForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
      var reallypass = this.$commonJs.getCookie('Password')
      if (inputpwd != reallypass) {
        this.errorShow = true
        this.errorMessage = "密码输入错误"
      } else {
        const apiPath = this.toggleText == '定投恢复' ? this.$apiPath.periodicPaymentStart : this.$apiPath.periodicPaymentPause
        this.$http.post(apiPath, {
          custno: this.$commonJs.getCookie('u_custno1'),
          buyplanno: this.buyplanno
        }).then(res => {
          // console.log(res);
          if (res.status !== 200) return
          if (res.data.code == "200" && res.data.success) {
            this.$message.success(res.data.data.message)
            this.$refs.cancelFormRef.resetFields()
            this.getFixedLists()
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: this.toggleText == '定投恢复' ? 19 : 18,
              fundname: "恒宝宝",
              money: "",
              dtDate: "",
              fundname2: ""
            })
          } else {
            this.$message.error('操作失败')
          }
          this.toggleDialogVisable = false
        }).catch(err => { })
      }
    },
  }
}
</script>

<style lang="less" scoped>
.openTit {
  margin: 20px 0 16px 0;
  color: @color;
  font-weight: bold;
}
// 终止
.terminationInvestment {
  width: 770px;
  margin: 20px auto;
  .tips {
    color: @rColor;
    margin: 19px 0 14px 15px;
  }
  .btnThree {
    margin-top: 40px;
    margin-bottom: 55px;
    margin-left: 53%;
    transform: translateX(-50%);
  }
}
.bank-warn {
  position: relative;
  padding: 0 20px;
  height: 35px;
  line-height: 35px;
  background: #fdf6ec;
  color: #e6a23c;
  span {
    cursor: pointer;
  }
  .el-icon-close {
    position: absolute;
    top: 10px;
    right: 20px;
    cursor: pointer;
  }
}
</style>
